import { useEffect, useState } from 'react';
import { apiFetch } from '../utils/api';
import { hasPermission } from '../utils/permissionControl';

/**
 * 坐标转换历史记录（含权限筛选）
 */
export default function useCoordinateToolHistory() {
  const [history, setHistory] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [canViewAllHistory, setCanViewAllHistory] = useState(() =>
    hasPermission('坐标转换历史记录查看')
  );

  const fetchHistory = async (filterUserId = null) => {
    try {
      let url = '/api/history/conversion';
      const params = new URLSearchParams();
      const allowAll = canViewAllHistory || hasPermission('坐标转换历史记录查看');
      if (allowAll && filterUserId) {
        params.append('user_id', filterUserId);
      }
      if (params.toString()) {
        url += '?' + params.toString();
      }

      const res = await apiFetch(url);
      const data = await res.json();
      if (data.success) {
        setHistory(data.history || []);
        if (data.meta && typeof data.meta.canViewAll === 'boolean') {
          setCanViewAllHistory(data.meta.canViewAll);
        }
        if (Array.isArray(data.filterUsers)) {
          setUsers(data.filterUsers);
        }
      }
    } catch (e) {
      console.error('获取历史记录失败:', e);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return {
    history,
    users,
    selectedUserId,
    setSelectedUserId,
    canViewAllHistory,
    fetchHistory
  };
}
